/**
 * Portal targets + events for collapsing Play Entry / Coaches Highlight into
 * the single slim shell header (chrome collapse).
 */
export const SHELL_GD_STATUS_ID = 'shell-gd-status';
export const SHELL_GD_CENTER_ID = 'shell-gd-center';
export const SHELL_GD_END_ID = 'shell-gd-end';

/** Dispatch to open the header ActiveEventSwitcher panel. */
export const OPEN_EVENT_SWITCHER_EVENT = 'gridiron:open-event-switcher';

export function openEventSwitcher(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_EVENT_SWITCHER_EVENT));
}
